module.exports = __webpack_public_path__ + "static/media/surgbook.800def20.png";